import { DocsLinksSection } from 'components/docs/docs-links-section';

const DocsIntroSection = ({ section }) => <DocsLinksSection icon='hand-wave' section={section} />;

export { DocsIntroSection };
